import { FC } from 'react';
import { SearchSuggestion } from './types';

import HotelIcon from 'assets/svg/Hotel.svg';
import LocationIcon from 'assets/svg/Location.svg';
import { Body, Small } from 'components/text';

import styles from './Suggestion.module.scss';
import { useSearchBarContext } from './context';
import InspirationCategoriesIcons from 'components/icons/InspirationCategories';

type SuggestionProps = {
  suggestion: SearchSuggestion;
};

const Suggestion: FC<SuggestionProps> = ({ suggestion }) => {
  const { setState } = useSearchBarContext();

  const handleClick = () => {
    setState({
      selectedSuggestion: suggestion,
      searchInputValue: suggestion.text,
      showSearchSuggestions: false,
      urlObject: {
        pathname: searchTypeToPathName[suggestion.type],
        query: { [searchTypeToIdPropertyName[suggestion.type]]: suggestion.id },
      },
    });
  };

  return (
    <div className={styles.container} onClick={handleClick}>
      {suggestion.type === 'category' ? (
        <InspirationCategoriesIcons
          icon={suggestion?.icon ? suggestion?.icon : ''}
        />
      ) : (
        searchTypeToIcon[suggestion.type]
      )}
      <div className={styles.content}>
        <Body>{suggestion.text}</Body>
        <Small xs color="grey-dark">
          {suggestion.location}
        </Small>
      </div>
    </div>
  );
};

export default Suggestion;

const searchTypeToIcon = {
  hotel: <HotelIcon />,
  city: <LocationIcon />,
};

const searchTypeToPathName = {
  hotel: '/our-hotels/[hotelId]',
  city: '/search-results/[locationId]',
  category: '/search-results-inspirations/[inspirationId]',
};

const searchTypeToIdPropertyName = {
  hotel: 'hotelId',
  city: 'locationId',
  category: 'inspirationId',
};
